<div class="message-input" role="group" aria-label="Message input">
  <label class="message-input__label" for="chatbot-message-input">Message input</label>
  <div class="message-input__row">
    <input
      #messageInput
      id="chatbot-message-input"
      class="message-input__field"
      type="text"
      placeholder="Type your message..."
      [disabled]="disabled"
      (keydown)="onKeyDown($event)"
    />
    <cwc-button
      *ngIf="!disabled"
      size="medium"
      message-input__send
      class="message-input__send"
      type="button"
      variant="icon"
      aria-label="Send message"
      leading-icon="send"
      [attr.disabled]="disabled ? true : null"
      (click)="onSendMessage()"
    >
    </cwc-button>
    <cwc-button
      *ngIf="disabled"
      message-input__stop
      class="message-input__stop"
      type="button"
      variant="icon"
      aria-label="Stop"
      leading-icon="stop-rounded-filled"
      (click)="onStop()"
    >
    </cwc-button>
  </div>
  <p class="message-input__disclaimer">
    This AI Assistant may produce inaccurate information. Powered by advanced language models.
  </p>
</div>
